import ClearIcon from "@mui/icons-material/Clear";
import { Collapse, Fade } from "@mui/material";
import {
  MRT_RowData,
  MRT_ShowHideColumnsButton,
  MRT_TableInstance,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleFullScreenButton,
  MRT_ToggleGlobalFilterButton,
} from "material-react-table";
import { useTranslation } from "react-i18next";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import styles from "@/components/tables/mrtToolbarInternalActions.module.css";

interface Props<TData extends MRT_RowData> {
  table: MRT_TableInstance<TData>;
  showReset: boolean;
  onReset: () => void;
}

const MrtToolbarInternalActions = <TData extends MRT_RowData>({
  table,
  showReset,
  onReset,
}: Props<TData>) => {
  const { t } = useTranslation();
  const {
    columnFilterDisplayMode,
    enableColumnFilters,
    enableColumnOrdering,
    enableColumnPinning,
    enableDensityToggle,
    enableFilters,
    enableFullScreenToggle,
    enableGlobalFilter,
    enableHiding,
    initialState,
  } = table.options;

  return (
    <>
      <Collapse
        orientation="horizontal"
        in={showReset}
        timeout={220}
        unmountOnExit
      >
        <Fade in={showReset} timeout={160}>
          <span className={styles.resetAllFiltersButtonWrapper}>
            <GenericButton
              className={styles.resetAllFiltersButton}
              variant="outlined"
              color="tertiary"
              startIcon={<ClearIcon />}
              onClick={onReset}
            >
              {t("reset_filters")}
            </GenericButton>
          </span>
        </Fade>
      </Collapse>
      {enableFilters && enableGlobalFilter && !initialState?.showGlobalFilter && (
        <MRT_ToggleGlobalFilterButton table={table} />
      )}
      {enableFilters &&
        enableColumnFilters &&
        columnFilterDisplayMode !== "popover" && (
          <MRT_ToggleFiltersButton table={table} />
        )}
      {(enableHiding || enableColumnOrdering || enableColumnPinning) && (
        <MRT_ShowHideColumnsButton table={table} />
      )}
      {enableDensityToggle && <MRT_ToggleDensePaddingButton table={table} />}
      {enableFullScreenToggle && <MRT_ToggleFullScreenButton table={table} />}
    </>
  );
};

export default MrtToolbarInternalActions;
